/* eslint-disable no-unused-vars */
window.jQuery = require('../../node_modules/jquery/dist/jquery');

window.$ = window.jQuery;



// WEBPACK FOOTER //
// ./_source/javascripts/vendor.js